import { NgModule } from '@angular/core';
import { ActualDatePipe } from './actual-date.pipe';
import { ShortNumberPipe } from './short-number.pipe';

@NgModule({
    imports: [],
    declarations: [ShortNumberPipe, ActualDatePipe],
    exports: [ShortNumberPipe, ActualDatePipe]
})
export class PipesCommonModule { }
